import React, { Component } from "react";
import {Container,Row,Col,Button, Form, FormGroup, Label, Input ,Modal,ModalBody,DropdownItem,DropdownMenu,UncontrolledDropdown,DropdownToggle } from 'reactstrap';
import httpClient from "../../../httpClient";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faAngleDown, faAngleLeft, faAngleRight, faPlusCircle, faTimes,
 } from '@fortawesome/free-solid-svg-icons'

 import { connect } from 'react-redux';
import { addVol } from "../../../slices/modalSlice";
import { TextareaAutosize } from "@mui/material";
import { TextField } from "@mui/material";
import DateTimePicker from '@mui/lab/DateTimePicker';

class AddVolAnnounce extends Component {
    constructor(props) {
        super(props);
        this.state = {
         VolCharterInfo: {title: '', description: '', prix:500,currency:"DZD",pays:"Algerie" ,region:"Chlef",commune:"Chlef" , linkGPS:'',nbrRoom:1,nbrAdulte:1,nbrChildren:1,equipement:[],dejeuné:"Inclus",annulation:"Remboursable",files:[],imagName:[]},
         typeVol : "Aller simple",
         sgDispo : null,
         paysDepart : "Pays",
         aeroport : "Aiereport",
         company : "Companie",
         poids : 23,
         escaleAero : "(ALG) Houari Boumedienne",
         escales : []

    }
   }

   toogleClose = () =>this.props.dispatch(addVol())
   getData_dropDown(e){
    e.preventDefault()
    this.setState({typeVol :e.currentTarget.textContent});
    
  }


  handleAddEscale = () => {
    const escales = this.state.escales;
    this.setState({ escales: [...escales, <Escale handler={() =>this.handleRemoveEscale(escales.length)} index={escales.length}/> ] });
  };

  handleRemoveEscale = (idx) => {
    const escales = this.state.escales;
      this.setState({ escales: escales.filter((escale, index) => index !== idx) });
    
  };
render(){
    return(
        <>
         <Modal isOpen={this.props.addVol} toggle={this.toogleClose} className="modal-width-addAnnoun" size="lg">

           <nav className="nav-windows-addanounce mb-3">
           <button className="close-heberg"  onClick={this.toogleClose} >
             <span><FontAwesomeIcon icon={faTimes}/></span>
           </button>
             <div className="title-announce">Nouvelle Annonce - Vol</div>
           </nav>

        <ModalBody className="">
            <Container>
                <div className="form__segment mb-4">
                    <div className="segment__head mb-4">
                        <h4 className="segment__head__txt">Informations de Base</h4>
                    </div>
                    <div className="segment__content d-flex align-items-end mb-4">
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Type de vol
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.typeVol}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Aller simple</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Aller - Retour</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="d-flex">
                          <label htmlFor="nbrAdulte">Sièges disponibles</label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce" name="sgDispo" value={this.state.sgDispo}/>
                          
                        </div>
                        
                    </div>
                    <div className="price__vol d-flex">
                       <div className="d-flex align-items-center">
                          <label htmlFor="nbrAdulte">Prix adulte</label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce col-4 " name="sgDispo" value={this.state.sgDispo}/>
                          <UncontrolledDropdown nav className=" px-0 nowrap ">
                         
                         <DropdownToggle className="button-add-pays title-announce-input">
                          DZD
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Eur</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>$</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        </div>
                        <div className="d-flex align-items-center">
                          <label htmlFor="nbrAdulte">Prix enfant</label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce col-4 " name="sgDispo" value={this.state.sgDispo}/>
                          <UncontrolledDropdown nav className=" px-0 nowrap ">
                         
                         <DropdownToggle className="button-add-pays title-announce-input">
                          DZD
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Eur</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>$</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        </div>
                        <div className="d-flex align-items-center">
                          <label htmlFor="nbrAdulte">Prix bébé</label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce col-4 " name="sgDispo" value={this.state.sgDispo}/>
                          <UncontrolledDropdown nav className=" px-0 nowrap ">
                         
                         <DropdownToggle className="button-add-pays title-announce-input">
                          DZD
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Eur</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>$</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        </div>
                    </div>

                </div>
                 <div className="form__segment mt-4  ">
                    <div className="segment__head mb-3">
                        <h4 className="segment__head__txt">Vol Aller</h4>
                    </div>
                    <div className="d-flex">
                    <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Pays de départ
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.paysDepart}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Algerie</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>France</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Airoport
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.aeroport}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>
                         
                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Compagnie aérienne
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.company}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Air Algérie</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Turkish airlines</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        
                    </div>
                    <div className="d-flex mt-3">
                    <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Pays d'arrivée
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.paysDepart}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Algerie</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>France</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Airoport
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.aeroport}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                      
                    </div>
                    <div className="mt-3">
                      <div className="d-flex">
                         <FormGroup className="mr-3">
                           <Label for="exampleDate">Date de départ</Label>
                           <Input type="date" name="date" id="exampleDate" placeholder="date placeholder" />
                         </FormGroup>
                         <FormGroup>
                           <Label for="exampleTime">Temp de départ</Label>
                           <Input type="time" name="time" id="exampleTime" placeholder="time placeholder" />
                         </FormGroup>
                      </div>
                      <div className="d-flex">
                         <FormGroup className="mr-3">
                           <Label for="exampleDate">Date d'arrivé</Label>
                           <Input type="date" name="date" id="exampleDate" placeholder="date placeholder" />
                         </FormGroup>
                         <FormGroup>
                           <Label for="exampleTime">Temp d'arrivé</Label>
                           <Input type="time" name="time" id="exampleTime" placeholder="time placeholder" />
                         </FormGroup>
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      Description
                      <TextareaAutosize placeholder="Décrivez votre annonce..." style={{height: "70px"}}/>
                    </div>
                    <div className="d-flex align-items-center mt-3">
                        <div>
                          <label htmlFor="nbrAdulte">Bagages en soute</label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce" name="sgDispo" value={this.state.sgDispo}/>
                        </div>
                        <UncontrolledDropdown nav className="col-3 d-flex align-items-center mr-4 ">
                         Poids
                         <DropdownToggle className="button-add-pays title-announce-input ml-2">
                          {this.state.poids} kg
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="d-flex align-items-center ml-2 mt-4">
                          <FormGroup check className="mr-4">
                            <Label check>
                              <Input type="checkbox" />{' '}
                              Bagage à main
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label check>
                              <Input type="checkbox" />{' '}
                              Bagage cabine
                            </Label>
                          </FormGroup>
                        </div>
                        
                    </div> 
                    <div>
                    <div className="form__segment mt-3">
                      <div className="segment__head mb-3">
                          <h4 className="segment__head__txt">Escales</h4>
                      </div>
                      <div>
                        {this.state.escales.map((item) => <div>{item}</div>)}
                      </div>
                      <div className="d-flex justify-content-center mt-2">
                        <Button onClick={this.handleAddEscale} className="d-flex align-items-center escale__btn"><FontAwesomeIcon icon={faPlusCircle} className="mr-2"/> Ajouter un escale</Button>
                      </div>
                    </div>
                    {this.state.typeVol === "Aller - Retour" && ( <div className="form__segment mt-3">
                      <div className="segment__head mb-3">
                          <h4 className="segment__head__txt">Vol retour</h4>
                      </div>
                      <div className="d-flex">
                    <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Pays de départ
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.paysDepart}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Algerie</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>France</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Airoport
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.aeroport}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>
                         
                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Compagnie aérienne
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.company}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Air Algérie</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Turkish airlines</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div className="d-flex mt-3">
                    <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Pays d'arrivée
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.paysDepart}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Algerie</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>France</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                         Airoport
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {this.state.aeroport}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                      
                    </div>
                    <div className="mt-3">
                      <div className="d-flex">
                         <FormGroup className="mr-3">
                           <Label for="exampleDate">Date de départ</Label>
                           <Input type="date" name="date" id="exampleDate" placeholder="date placeholder" />
                         </FormGroup>
                         <FormGroup>
                           <Label for="exampleTime">Temp de départ</Label>
                           <Input type="time" name="time" id="exampleTime" placeholder="time placeholder" />
                         </FormGroup>
                      </div>
                      <div className="d-flex">
                         <FormGroup className="mr-3">
                           <Label for="exampleDate">Date d'arrivé</Label>
                           <Input type="date" name="date" id="exampleDate" placeholder="date placeholder" />
                         </FormGroup>
                         <FormGroup>
                           <Label for="exampleTime">Temp d'arrivé</Label>
                           <Input type="time" name="time" id="exampleTime" placeholder="time placeholder" />
                         </FormGroup>
                      </div>
                    </div>
                   
                    <div className="d-flex align-items-center mt-3">
                        <div>
                          <label htmlFor="nbrAdulte">Bagages en soute</label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce" name="sgDispo" value={this.state.sgDispo}/>
                        </div>
                        <UncontrolledDropdown nav className="col-3 d-flex align-items-center mr-4 ">
                         Poids
                         <DropdownToggle className="button-add-pays title-announce-input ml-2">
                          {this.state.poids} kg
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="d-flex align-items-center ml-2 mt-4">
                          <FormGroup check className="mr-4">
                            <Label check>
                              <Input type="checkbox" />{' '}
                              Bagage à main
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label check>
                              <Input type="checkbox" />{' '}
                              Bagage cabine
                            </Label>
                          </FormGroup>
                        </div>
                        </div>
                      </div>)}
                    </div>
                    </div>
                    <div>
                        <FormGroup className="mt-5" check>
                            <Label check>
                              <Input type="checkbox" />{' '}
                              Je confirme que toutes les informations déclarées sont correctes, et j'assume toute fausse déclaration
                            </Label>
                          </FormGroup>
                       
                    </div>
                    <div className="buttons-add-announce mt-0">
                         <Button className=" button-add-moule retour-button"><FontAwesomeIcon id="arrow-retour"  icon={faAngleLeft} />Retour</Button>
                         <Button className=" button-add-moule suivant-button" 
                             onClick={(evt=>{
                               this.toogleClose();
                               
                               //  this.props.dispatch(addHeberg());
                         }
                               
                             )} 
                        >Enregistrer<FontAwesomeIcon id="arrow-suivant"  icon={faAngleRight} /></Button>
                </div>
                
            </Container>
        </ModalBody>
</Modal>

        </>

    )
}
 

}
 

function Escale(props) {
  return (
    <div className="  mb-3">
    <div className="d-flex jusify-content-center mb-2">
       <span className="escale__nbr text-center mx-auto">Escale numéro {props.index+1}</span>
    </div>
      <div className="escale__forms d-flex justify-content-between align-items-center">
        <div>
        <div className="d-flex align-items-center">
        <UncontrolledDropdown nav className="px-0 col-6 d-flex align-items-center mr-2 ">
      <span className="text-nowrap mr-2">
      Airoport d'escale
      </span>
      
       <DropdownToggle className="button-add-pays title-announce-input ">
        Houari
          <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
        </DropdownToggle>
        <DropdownMenu right className="full-width">
          <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Houari Boumedienne</DropdownItem>
          <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>cenia</DropdownItem>

        </DropdownMenu>
      </UncontrolledDropdown>
      <div className="mt-3 col-6 d-flex align-items-center">
        <label htmlFor="nbrAdulte">Durée (Heure)</label>
        <input type="number"  min="1" defaultValue = "1" className="number-input-announce" name="sgDispo" />
      </div>
      </div>
      <div className="d-flex mt-2">
               <FormGroup className="mr-3">
                 <Label for="exampleDate">Date</Label>
                 <Input type="date" name="date" id="exampleDate" placeholder="date placeholder" />
               </FormGroup>
               <FormGroup>
                 <Label for="exampleTime">Heure</Label>
                 <Input type="time" name="time" id="exampleTime" placeholder="time placeholder" />
               </FormGroup>
      </div>
        </div>
         
      <FontAwesomeIcon icon={faTimes} onClick={props.handler}   className='delete__escale'/>
      </div>
     

    </div>
  )
}


function mapStateToProps(state) {
  return {
    
    addVol: state.modal.addVol,
    

  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddVolAnnounce);